// @ts-nocheck
import _ from 'lodash';
import qs from 'query-string';
import React, { Component } from 'react';
import { inject, observer } from "../../../stores/mobx-compat";
import { Route, Routes } from 'react-router-dom';
import { withRouter } from '../../../router-compat';

import PageHeader from '../../ui/PageHeader';
import Card from '../../ui/Card';
import Pill from '../../ui/Pill';
import configs from './configs';

import OMI366 from './OMI366';
import HubSpot from './HubSpot';
import Salesforce from './Salesforce';
import WiX from './WiX';
import GoogleAdwordsPage from './GoogleAdwords';
import GoogleTagManager from './GoogleTagManager';
import Shopify from './Shopify';
import Mailchimp from './Mailchimp';
import SalesforceMarketingCloud from './SalesforceMarketingCloud';
import Typeform from './Typeform';
import Pipedrive from './Pipedrive';
import Blitz from './Blitz';
import Fanbridge from './Fanbridge';

class Integrations extends Component {
  componentDidMount() {
    const { code } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    const { pathname } = this.props.location;
    if (code && (pathname.endsWith('integrations') || pathname.endsWith('integrations/'))) {
      this.props.history.push(`/integrations/HubSpot?code=${code}`);
    }
  }

  renderGrid = () => (
    <>
      <PageHeader
        eyebrow="Integrations"
        title={<>Connect <em>everything</em>.</>}
        sub="Pipe captures into your CRM, email tool, or ads stack."
      />
      <div
        className="grid gap-4"
        style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))' }}
      >
        {Object.values(configs).map((c) => {
          const ready = c.status === 'Ready' || c.status === 'Integration Ready';
          return (
            <Card
              key={c.key}
              padded
              interactive
              className="cursor-pointer flex flex-col"
              onClick={() => this.props.history.push(`/integrations/${c.key}`)}
            >
              <div
                className="grid place-items-center mb-3"
                style={{
                  height: 90,
                  background: 'var(--mov-paper-2)',
                  borderRadius: 10,
                  border: '1px solid var(--mov-line)',
                }}
              >
                <img
                  src={c.logo}
                  alt={c.displayName}
                  style={{ maxWidth: '70%', maxHeight: '60%', objectFit: 'contain' }}
                />
              </div>
              <div className="flex items-center justify-between gap-2 mb-2">
                <h3 className="m-0 text-[15px] font-semibold">{c.displayName}</h3>
                <Pill tone={ready ? 'green' : 'amber'} dot>{c.status}</Pill>
              </div>
              <p className="m-0 text-[13px] text-mov-ink-soft" style={{ minHeight: 38 }}>
                {c.desc}
              </p>
            </Card>
          );
        })}
      </div>
    </>
  );

  render() {
    return (
      <Routes>
        <Route index element={this.renderGrid()} />
        <Route path="OMI366" element={<OMI366 />} />
        <Route path="HubSpot" element={<HubSpot />} />
        <Route path="Salesforce" element={<Salesforce />} />
        <Route path="WiX" element={<WiX />} />
        <Route path="GoogleAdwords" element={<GoogleAdwordsPage />} />
        <Route path="GoogleTagManager" element={<GoogleTagManager />} />
        <Route path="Shopify" element={<Shopify />} />
        <Route path="Mailchimp" element={<Mailchimp />} />
        <Route path="SalesforceMarketingCloud" element={<SalesforceMarketingCloud />} />
        <Route path="Typeform" element={<Typeform />} />
        <Route path="Pipedrive" element={<Pipedrive />} />
        <Route path="Blitz" element={<Blitz />} />
        <Route path="Fanbridge" element={<Fanbridge />} />
      </Routes>
    );
  }
}

export default withRouter(inject('store')(observer(Integrations)));
